
















































import Vue from 'vue'
import {
  Component, Prop, Emit, Watch,
} from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbLoadingService } from '@/shared/loading/loading.service';
import ContractInstance from '@/domain/contract/entity/contract-instance.entity';
import BoundInstanceRequest from '@/domain/contract/request/bound-instances-request.entity';
import BoundInstances from '@/domain/contract/entity/bound-instances.entity';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ContractService from '@/domain/contract/service/contract.service';
import ModalOptions from '../../../../../shared/modal/modal-options.entity';
import ContractItem from '../../../../../domain/contract/entity/contract-item.entity';

@Component({
  components: {
    ModalComponent,
    VbTooltipSlot,
    LabelSlot,
  },
})
export default class SelectInstanceModal extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({ required: true, default: '' })
  businessUnitId!: string;

  @Prop({ required: true })
  item!: ContractItem;

  @Prop({ required: true })
  instances!: ContractInstance[];

  boundInstances: BoundInstanceRequest = new BoundInstanceRequest({});

  @Watch('show')
  applyBoundedItems() {
    this.item.boundInstances.forEach((el: BoundInstances) => {
      this.boundInstances.addNewInstance(el.id);
    });
  }

  get options(): ModalOptions {
    return {
      title: 'Configuração de instâncias',
      titleAlign: 'center',
      showClose: false,
      showOk: true,
      labelOk: 'Salvar',
      okColor: 'bluePrimary',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 720,
      persistent: false,
    }
  }

  bindInstances() {
    ContractService.bindInstancesToItem(
      this.businessUnitId, this.item.id, this.boundInstances,
    ).then((response: any) => {
      VbSnackbarService.showSuccess('Instâncias vinculadas com sucesso');
      this.success();
    })
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  @Emit('success')
  private success(): void {}

  @Emit('cancel')
  private cancel(): void {}
}
